// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"6JpdD":[function(require,module,exports) {
require("93249a86e2e5fba8").register(JSON.parse('{"aJUMN":"removeAccount.549ee956.js","k8qgN":"user.63573a06.svg","ckW5F":"index.919a24ef.js","ikhXE":"index.36bc93d7.js"}'));

},{"93249a86e2e5fba8":"fyJL2"}],"fyJL2":[function(require,module,exports) {
"use strict";
var mapping = {};
function register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)mapping[keys[i]] = pairs[keys[i]];
}
function resolve(id) {
    var resolved = mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
module.exports.register = register;
module.exports.resolve = resolve;

},{}],"gM4mH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _auth = require("firebase/auth");
var _common = require("./common");
var _config = require("./config");
var _database = require("firebase/database");
var _userSvg = require("url:../images/user.svg");
var _userSvgDefault = parcelHelpers.interopDefault(_userSvg);
"use strict";
let lang;
let ivUser;
let spAcc;
let btnContinue, btnCancelLogin, btnVerifyAcc, btnCancelVerify, btnDeleteAcc, btnCancelDelete, btnErrorOK, btnOkSuccess;
let pMsg;
let modLogin, modPwVerify, modDeleteAcc, modDeletingAcc, modError, modSuccess, modLoader;
let inPw;
let user;
let recentLogin;
let auth;
$(document).ready(function() {
    $(function() {
        (0, _common.initFooter)();
        lang = (0, _common.initLangCookie)();
        (0, _common.initLangAction)();
        initUi();
        getUser();
    });
});
function initUi() {
    if (window.location.search.includes("action=success")) recentLogin = true;
    ivUser = document.getElementById("ivUser");
    spAcc = document.getElementById("spAcc");
    btnContinue = document.getElementById("btnContinue");
    modLogin = document.getElementById("modLogin");
    btnCancelLogin = document.getElementById("btnCancel");
    modPwVerify = document.getElementById("modPwVerify");
    inPw = document.getElementById("inPw");
    btnVerifyAcc = modPwVerify.querySelector(".btnVerify");
    btnCancelVerify = modPwVerify.querySelector(".btnCancel");
    modDeleteAcc = document.getElementById("modDeleteAcc");
    btnDeleteAcc = document.getElementById("btnDeleteAcc");
    btnCancelDelete = modDeleteAcc.querySelector(".btnCancel");
    modDeletingAcc = document.getElementById("modDeletingAcc");
    modError = document.getElementById("modError");
    pMsg = document.getElementById("pMsg");
    btnErrorOK = document.getElementById("btnOk");
    modSuccess = document.getElementById("modSuccess");
    btnOkSuccess = document.getElementById("btnOkSuccess");
    modLoader = document.getElementById("modLoader");
}
function getUser() {
    auth = (0, _config.initAuth);
    let startLs = true;
    (0, _auth.onAuthStateChanged)(auth, (data)=>{
        user = data;
        if (startLs) {
            startLs = false;
            initLs();
        }
        if (user) getUserInfo();
    });
}
function getUserInfo() {
    spAcc.textContent = user.email;
    let dbUser = (0, _database.ref)((0, _config.db), `user/${user.uid}`);
    (0, _database.onValue)(dbUser, (data)=>{
        if (data.exists()) {
            let info = data.val();
            ivUser.src = info.imgUrl ? info.imgUrl : (0, _userSvgDefault.default);
        }
    }, {
        onlyOnce: true
    });
}
function initLs() {
    $(ivUser).on("error", function() {
        ivUser.src = (0, _userSvgDefault.default);
    });
    $(btnContinue).click(function() {
        if (recentLogin) (0, _common.setDisplay)(modDeleteAcc, "flex");
        else if (user) (0, _common.setDisplay)(modPwVerify, "flex");
        else (0, _common.setDisplay)(modLogin, "flex");
    });
    $(btnCancelLogin).click(function() {
        (0, _common.setDisplay)(modLogin, "none");
    });
    $(btnVerifyAcc).click(function() {
        verifyEmail();
    });
    $(btnCancelVerify).click(function() {
        (0, _common.setDisplay)(modPwVerify, "none");
    });
    $(btnErrorOK).click(function() {
        (0, _common.setDisplay)(modError, "none");
    });
    $(btnDeleteAcc).click(function() {
        (0, _common.setDisplay)(modDeleteAcc, "none");
        deleteAccount();
    });
    $(btnCancelDelete).click(function() {
        (0, _common.setDisplay)(modDeleteAcc, "none");
    });
    $(btnOkSuccess).click(function() {
        window.location.replace("../login.html");
    });
}
function deleteAccount() {
    (0, _common.setDisplay)(modDeletingAcc, "flex");
    (0, _auth.deleteUser)(user).then(()=>{
        (0, _common.setDisplay)(modSuccess, "flex");
        (0, _common.setDisplay)(modDeletingAcc, "none");
    }).catch((e)=>{
        recentLogin = false;
        pMsg.textContent = "Could not delete account";
        (0, _common.setDisplay)(modError, "flex");
        (0, _common.setDisplay)(modDeletingAcc, "none");
    });
}
function verifyEmail() {
    let pw = inPw.value.trim();
    if (pw) {
        inPw.value = "";
        (0, _common.setDisplay)(modPwVerify, "none");
        (0, _common.setDisplay)(modLoader, "flex");
        let cred = (0, _auth.EmailAuthProvider).credential(user.email, pw);
        (0, _auth.reauthenticateWithCredential)(user, cred).then(()=>{
            recentLogin = true;
            (0, _common.setDisplay)(modDeleteAcc, "flex");
            (0, _common.setDisplay)(modLoader, "none");
        }).catch((e)=>{
            pMsg.textContent = "Could not authenticate your account";
            (0, _common.setDisplay)(modError, "flex");
            (0, _common.setDisplay)(modLoader, "none");
        });
    } else {
        (0, _common.shake)(inPw);
        (0, _common.showToast)("error", "Password cannot be empty");
    }
}

},{"firebase/auth":"8Nm6e","./common":"loJev","./config":"cl3hM","firebase/database":"gGruC","url:../images/user.svg":"aqFzn","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aqFzn":[function(require,module,exports) {
module.exports = require("a85e7ae39fdc9edd").getBundleURL("aJUMN") + require("c51613e8a9e32896").resolve("k8qgN");

},{"a85e7ae39fdc9edd":"c7Tr5","c51613e8a9e32896":"fyJL2"}],"c7Tr5":[function(require,module,exports) {
"use strict";
var bundleURL = {};
function getBundleURLCached(id) {
    var value = bundleURL[id];
    if (!value) {
        value = getBundleURL();
        bundleURL[id] = value;
    }
    return value;
}
function getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return getBaseURL(matches[2]);
    }
    return "/";
}
function getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
exports.getBundleURL = getBundleURLCached;
exports.getBaseURL = getBaseURL;
exports.getOrigin = getOrigin;

},{}]},["6JpdD","gM4mH"], "gM4mH", "parcelRequiref9e4")

//# sourceMappingURL=removeAccount.549ee956.js.map
